// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';

export const CHARTS = {
  sectorComposition: (
    <Translation
      i18nKey="charts.sectorComposition"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  segmentMatrix: (
    <Translation
      i18nKey="charts.segmentMatrix"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  factors: (
    <Translation
      i18nKey="charts.factors"
      ns="popups"
      components={{
        p: <p className="text-justify" />,
        ul: <ul />,
        li: <li />,
        strong: <strong />,
      }}
      tOptions={{
        interpolation: { escapeValue: false },
      }}
    />
  ),

  valueAtRisk: (
    <Translation
      i18nKey="charts.valueAtRisk"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  concentration: (
    <Translation
      i18nKey="charts.concentration"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  topAssets: (
    <Translation
      i18nKey="charts.topAssets"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  trackingDifference: (
    <Translation
      i18nKey="charts.trackingDifference"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  trackingError: (
    <Translation
      i18nKey="charts.trackingError"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  aggregatorReturns: (
    <Translation
      i18nKey="charts.aggregatorReturns"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  returns: (
    <Translation
      i18nKey="charts.returns"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  correlationMatrix: (
    <Translation
      i18nKey="charts.correlationMatrix"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  riskVsReturn: (
    <Translation
      i18nKey="charts.riskVsReturn"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
};

export type ChartPopupName = keyof typeof CHARTS;
